import { memo } from 'react';
import type { PlatformFontEntry } from '@/player-config/src/types/brand-kit-types';
import { classnames } from '@/libs/utils';

interface FontListProps {
  entries: PlatformFontEntry[];
  selectedUrl: string;
  selectedDisplayName?: string;
  onSelect: (url: string, name: string) => void;
  'data-testid'?: string;
}

function FontList({
  entries,
  selectedUrl,
  selectedDisplayName,
  onSelect,
  'data-testid': testId
}: FontListProps): JSX.Element {
  return (
    <ul className="mt-1 list-none space-y-0.5 p-0" data-testid={testId}>
      {entries.map(({ url, name }) => {
        const selected = url === selectedUrl && (selectedDisplayName === undefined || name === selectedDisplayName);
        return (
          <li key={`${url}::${name}`}>
            <button
              type="button"
              data-testid={`font-option-${name}`}
              onClick={() => onSelect(url, name)}
              className={classnames(
                'w-full truncate rounded-md px-2 py-2.5 text-left text-sm text-slate-900 transition-colors',
                selected ? 'bg-slate-100 font-medium' : 'hover:bg-slate-50'
              )}
              style={{ fontFamily: `"${name}"` }}
            >
              {name}
            </button>
          </li>
        );
      })}
    </ul>
  );
}

export default memo(FontList);
